import React, { useEffect, useState } from 'react';
import { Range, DateRange, RangeKeyDict } from 'react-date-range';
import { X } from 'lucide-react';
import { isMobile } from '../../utils/deviceUtils';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

interface DateRangePickerProps {
  dateRange: Range[];
  onDateChange: (ranges: RangeKeyDict) => void;
  isOpen: boolean;
  toggleOpen: () => void;
  pickerRef: React.RefObject<HTMLDivElement>;
}

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  dateRange,
  onDateChange,
  isOpen,
  toggleOpen,
  pickerRef,
}) => {
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    setIsMobileDevice(isMobile());
  }, []);

  // Ensure we have valid dates
  const validDateRange = dateRange.map(range => ({
    ...range,
    startDate:
      range.startDate instanceof Date && !isNaN(range.startDate.getTime())
        ? range.startDate
        : new Date(),
    endDate:
      range.endDate instanceof Date && !isNaN(range.endDate.getTime())
        ? range.endDate
        : new Date(),
  }));

  if (!isOpen) return null;

  return (
    <div
      className="absolute z-[9999] mt-2 left-1/2 -translate-x-1/2"
      ref={pickerRef}
    >
      <button
        onClick={toggleOpen}
        className="absolute top-2 right-2 p-1.5 rounded-lg hover:bg-neutral-100 transition-colors z-10"
        aria-label="Close date picker"
      >
        <X className="w-4 h-4 text-neutral-500" />
      </button>
      <DateRange
        onChange={onDateChange}
        moveRangeOnFirstSelection={false}
        months={isMobileDevice ? 1 : 2}
        ranges={validDateRange}
        direction="horizontal"
        minDate={new Date()}
        rangeColors={['#3B82F6']}
        showDateDisplay={false}
        showMonthAndYearPickers={true}
        showMonthArrow={true}
        showPreview={true}
        className="bg-white border border-neutral-200 rounded-xl sm:rounded-xl shadow-large"
        dateDisplayFormat="dd MMM yyyy"
      />
    </div>
  );
};
